import { THUMBNAIL_COMPANY_LP_HH } from '../../@core/utilities/Constant'
import React, { FC } from 'react'
import ContactWrapper from 'src/@legacy/wrapper/contact'
import { LINK_URL_EMPLOYER_CONTACT } from 'src/@legacy/utilities/LinkURL'
import PublicPageMeta from 'src/@legacy/@core/components/SEOMeta/PublicPageMeta'
import Head from 'next/head'

const ContactPage: FC = () => {
  return (
    <>
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `!function(){if(!window.EncTracking||!window.EncTracking.started){window.EncTracking=Object.assign({}, window.EncTracking, {queue:window.EncTracking&&window.EncTracking.queue?window.EncTracking.queue:[],track:function(t){this.queue.push({type:"track",props:t})},identify:function(t){this.queue.push({type:"identify",props:t})},started:!0});var t=window.EncTracking;t.writeKey="waL8BTHXFqJz1Prr1eFzc84QL",t.hasOptedIn=true,t.shouldGetConsent=true,t.hasOptedIn&&(t.shouldGetConsent=!1),t.optIn=function(){t.hasOptedIn=!0,t&&t.init&&t.init()},t.optOut=function(){t.hasOptedIn=!1,t&&t.setOptOut&&t.setOptOut(!0)};var n=function(t){var n=document.createElement("script");n.type="text/javascript",n.async=void 0===t||t,n.src="https://resources-app.encharge.io/encharge-tracking.min.js";var e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};"complete"===document.readyState?n():window.attachEvent?window.attachEvent("onload",n):window.addEventListener("load",n,!1)}}();`
          }}
        />
      </Head>
      <PublicPageMeta
        title="freeC Asia | Tuyển Dụng Nhân Sự Cao Cấp - Dịch Vụ Headhunter"
        description="Tiếp cận ứng viên hàng đầu bằng dịch vụ headhunt chuyên nghiệp cùng các chuyên gia headhunter trong lĩnh vực quản lý, lập trình, IT, thiết kế, bán hàng, marketing và nhiều hơn nữa."
        keywords="dịch vụ headhunt, headhunter, dịch vụ săn đầu người, dịch vụ thuê nhân sự, tuyển dụng cấp cao, dịch vụ tuyển dụng cấp cao, tuyển dụng chất lượng cao"
        image={`${process.env.NEXT_PUBLIC_APP_DOMAIN}${THUMBNAIL_COMPANY_LP_HH}`}
        url={`${process.env.NEXT_PUBLIC_APP_DOMAIN}${LINK_URL_EMPLOYER_CONTACT}`}
      />

      <ContactWrapper />
    </>
  )
}
export default ContactPage
